import type { User } from '@axiom/validation';

export const UserFullNameUtil = (id: string, usersArray: User[]): string => {
  const userDetails = usersArray.find((u: User) => u.id === id);

  return `${userDetails?.firstName || ''} ${
    userDetails?.lastName || ''
  }`.trim();
};
